// extracted by mini-css-extract-plugin
export default {"layout":"style_layout__bRQsH","floatingAIButton":"style_floatingAIButton__ihp61"};